<template>
  <div class="footer">
    <div class="sections">
      <div class="section">
        <div class="title">SPONSORS</div>
        <div class="sponsor">
          <img src="" alt="">
          <a href="https://www.facebook.com/PatrasAeroclub1980?locale=el_GR">Patras Aeroclub</a>
        </div>
        <div class="sponsor">
          <img src="" alt="">
          <a href="https://www.instagram.com/sempreviva.deli/">Sempre Viva</a>
        </div>
        <div class="sponsor">
          <img src="" alt="">
          <a href="https://www.google.gr/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&cad=rja&uact=8&ved=2ahUKEwjg7fjOvruJAxXUVkEAHX8KLa0QFnoECA0QAQ&url=https%3A%2F%2Fbox.gr%2F&usg=AOvVaw1gjPfgX1kofX15iKXDdxwx&opi=89978449">BOX</a>
        </div>
      </div>
      <div class="section">
        <img class="image" src="../assets/EuroAviaBridge.png" alt="">
      </div>
      <div class="section">
        <div class="title">CONTACTS</div>
        <div class="contact">
          <img src="" alt="">
          <a href="https://www.instagram.com/20moi.vol8/">Instagram</a>
        </div>
        <div class="contact">
          <img src="" alt="">
          <a href="https://www.linkedin.com/company/euroavia-patras/">Linkedin</a>
        </div>
        <div class="contact">
          <img src="" alt="">
          <a href="https://www.youtube.com/@EUROAVIAPatras">Youtube</a>
        </div>
      </div>
    </div>
    
    <div class="credits">
      <div class="developed">Developed by:</div>
      <a href="https://novumwebsolutions.com/" target="_blank" class="novumWebLink">
        <div class="novumWeb">
          <div class="Nov">NOVUM</div>
          <div class="Web">Web Solutions</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSection',
};
</script>

<style lang="scss" scoped>
.footer {
  background: #6685A3;
  padding: 50px 70px;
  margin-top: 50px;
  position: relative;
  z-index: 1;

  .sections {
    display: flex;
    justify-content: space-between;
    margin: 0px 15%;
    
    .title {
      font-family: Calibri, sans-serif;
      font-weight: bold;
      font-size: 40px;
      color: #00284d;
      margin-bottom: 20px;
    }
    
    a {
      font-family: Calibri, sans-serif;
      font-size: 20px;
      text-decoration: none;
      font-weight: bold;
      color: #00284d;
      display: inline-block;
    }
    
    .section {
      display: flex;
      flex-direction: column;

      img {
        width: 200px;
        height: auto;
      }
      
      .sponsor, .contact {
        padding: 5px 0;
        text-align: center;
      }
    }
  }
  
  .credits {
    color: #00284d;
    font-family: 'Nico Moji', sans-serif;
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    
    .developed {
      margin-right: 20px;
      font-size: 14px;
    }

    a.novumWebLink {
      text-decoration: none;
      display: inline-block;
    }
    
    .novumWeb {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #252F34;
      padding: 5px 10px;
      border-radius: 5px;
      
      .Nov {
        font-size: 19px;
        color: #FFFFFF;
      }
      
      .Web {
        font-size: 8.5px;
        color: #0EA47A;
      }
    }
  }

  @media (max-width: 768px) {
    .sections {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: column;
      
      .section {
        margin-bottom: 40px;

        .title {
          font-size: 30px;
        }

        a {
          font-size: 18px;
        }

        img {
          display: none;
        }

        .novumWeb .Nov {
          font-size: 17px;
        }

        .novumWeb .Web {
          font-size: 7px;
        }
      }
    }

    .credits {
      flex-direction: column;
      padding-top: 20px;
      margin-top: 50px;
  
      .developed {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
